var _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVerticalDots = function SvgVerticalDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#061E2D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5,
    r: 1,
    transform: "rotate(90 8 5)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 1,
    transform: "rotate(90 8 8)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 11,
    r: 1,
    transform: "rotate(90 8 11)"
  })));
};

export { SvgVerticalDots as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0iIzA2MUUyRCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjUiIHI9IjEiIHRyYW5zZm9ybT0icm90YXRlKDkwIDggNSkiLz4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjEiIHRyYW5zZm9ybT0icm90YXRlKDkwIDggOCkiLz4KPGNpcmNsZSBjeD0iOCIgY3k9IjExIiByPSIxIiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA4IDExKSIvPgo8L3N2Zz4K";